import styled from 'styled-components';

export const TourFilterSectionWrapper = styled.section`
  width: 100%;
  padding: 12px;
  margin-bottom: 20px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.white};

  button {
    display: block;
    padding: 0;
    margin: 10px 0 0;
    border: 0;
    background: transparent;
    color: ${({ theme }) => theme.palette.clearBlue};
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
  }

  .setur-collapse-header {
    padding: 0 !important;
  }

  .setur-collapse-content-active {
    margin-top: 10px;
  }

  & > * > strong {
    color: rgb(47, 49, 55);
  }

  & > .setur-collapse {
    color: rgb(47, 49, 55);
  }

  & > .setur-collapse .setur-collapse-header {
    color: rgb(47, 49, 55);
  }

  & > .setur-collapse .setur-collapse-header span {
    color: rgb(47, 49, 55);
  }

  & > strong,
  & > .setur-collapse {
    font-size: 16px;
    font-weight: 700;
  }
`;

export const TourFilterSectionTitle = styled.span`
  color: rgb(47, 49, 55);
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
`;

export const TourFilterSectionContent = styled.div`
  margin-top: 10px;
`;

export const TourFilterItemsWrapper = styled.div<{ $isScrollable?: boolean }>`
  ${({ $isScrollable }) =>
    $isScrollable &&
    `
    max-height: 400px;
    overflow-y: auto;
    padding-right: 4px;
  `}
`;

export const TourFilterSearchWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  padding: 0 10px;
  margin-bottom: 10px;
  border: 1px solid ${({ theme }) => theme.palette.inputBorderColor};
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.inputBackgroundColor};
`;

export const TourFilterSearchInput = styled.input`
  width: 100%;
  height: 100%;
  padding: 0 0 0 8px;
  border: 0;
  outline: 0;
  background: transparent;
  color: ${({ theme }) => theme.palette.inputColor};
  font-size: 14px;
`;

export const TourFilterCard = styled.div`
  width: 100%;
  padding: 12px;
  margin-bottom: 20px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.white};
`;
